/**
 * /superadmin/recovery — SuperAdmin recovery queue (route shell).
 * Screen impl in `./recovery-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/superadmin/recovery')({
  component: lazyRouteComponent(
    () => import('./recovery-screen'),
    'RecoveryScreen',
  ),
});
